import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleConfiguration = {
  namespaced: true,

  state: {
    name: 'configuration',
    nextSeqCode: null,
    
    configurations: []
  },

  mutations,
  getters,
  actions
}

export default moduleConfiguration;